// removed by extract-text-webpack-plugin
module.exports = {"serviceCard":"_1myb81IyupeMnhd6HqUUUy","groupTitle":"GQT1_t07tDPjko4bx9U78","duration":"_3-k6xTKaM1lP9LWEocrym_","groupPrice":"_268m_yvGd5awQlxIpOLJOI","newPrice":"_2VsEOl4zcAEeynOJsElgtb","oldPrice":"_1kxa6rNcAHNovnuFGZEtfj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ServiceCardBooking.scss
// module id = 1112
// module chunks = 0